import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../assets/logo.png';
import 'animate.css';
import RightLine from '../assets/rightline.png';
import LeftLine from '../assets/leftline.png';

const StartPage = () => {
  return (
    <>
      <div className="container">
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <img src={logo} alt="Logo" className="img-fluid text-center animate__animated animate__fadeInDown" />
        </div>
      </div>

      <div>
        <img src={RightLine} alt="Right Line" className="ms-auto RightLine img-fluid" />
      </div>

      <div>
        <img src={LeftLine} alt="Left Line" className="LeftLine img-fluid" />
      </div>
    </>
  );
};

export default StartPage;
